module.exports = __webpack_public_path__ + "static/media/kredyt_18.074753d9.png";